<template>
  <!--
    Crawlable job links for clients that do not execute JavaScript (non-Google /
    AI crawlers). The search UI is client-only, so without this the initial HTML
    has zero paths to individual job pages. Wrapped in <noscript> so it is
    invisible to real (JS-enabled) users and produces no hydration flash, while
    remaining in the raw HTML that non-JS crawlers parse. Links come from the
    offer document's own `url`, so they are identical to the visible results —
    no cloaking. (JET-1826)

    data-allow-mismatch: with JS enabled the browser parses <noscript> content as
    an inert text node, so Vue's client vdom (a <ul>) can never match the DOM
    (text). The SSR HTML is correct — which is all that matters for crawlers —
    and JS users never see this, so the hydration mismatch is intentional. The
    attribute must live on the <noscript> (the only real DOM ancestor on the
    client) for Vue to honour it.
  -->
  <noscript data-allow-mismatch>
    <ul>
    <li v-for="link in links" :key="link.url">
    <a :href="link.url">{{ link.title }}</a>
    </li>
    </ul>
  </noscript>
</template>

<script setup lang="ts">
import type { SsrJobLink } from "~/composables/useSsrJobLinks"

defineProps<{
  links: SsrJobLink[]
}>()
</script>
